const TechnicalLV16 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>Kad jāmaina riepas</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Labas riepas var droši kalpot vairākus gadus. Tas ir atkarīgs no braukšanas paradumiem, riepu kvalitātes, nobraukuma un riepu glabāšanas apstākļiem. Ir svarīgi laikus pamanīt faktorus, kas liecina, ka pienācis laiks iegādāties jaunas riepas.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Galvenie rādītāji</strong></span></p>

            <p>&nbsp;</p>

            <ul>
                <li>Riepu protektora dziļums</li>
                <li>Riepu vecums</li>
                <li>Riepu gumijas īpašību izmaiņas, piemēram, plaisas un elastības zudums</li>
            </ul>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Riepu vecums</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepu ražotāji drošības nolūkos iesaka neizmantot riepas, kas ražotas vairāk nekā pirms 10 gadiem. Tātad, ja plānots riepas izmantot 3 gadus, tad pirkšanas brīdī riepas drīkst būt 7 gadus vecas. <strong>Michelin</strong> ir veicis arī interesantus pētījumus, kuros secināts, ka riepas, kuras tiek ekspluatētas uz automašīnas trīs nedēļas, kvalitātes ziņā ir līdzvērtīgas riepām, kuras vienu gadu glabājas noliktavā.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Kā noteikt riepu vecumu</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tehnisko apskašu rezultāti liecina, ka Latvijā vidējais riepu vecums ir 8 gadi, taču daudzi autovadītāji mēdz braukt arī ar vecākām riepām. Lai novērstu braukšanu ar nolietotām un vecām riepām, tehniskās apskates punktos nosaka vecākās riepas izgatavošanas gadu.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Turklāt ikviens autovadītājs var noteikt savas automašīnas riepu vecumu. Uz riepas sānu malas ir atrodams apzīmējums <strong>DOT</strong> kopā ar burtu un skaitļu kombināciju, kas norāda riepas izgatavošanas gadu.</p>
        </div>
    );
};

export default TechnicalLV16;

